import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom'
import { loadStripe } from "@stripe/stripe-js"
import { VITE_STRIPE_PUBLIC_KEY } from "env"
import { toast } from "react-toastify";
import { 
  Elements, 
  CardNumberElement, 
  CardExpiryElement, 
  CardCvcElement, 
  useStripe, 
  useElements 
} from "@stripe/react-stripe-js";
import { mixPostV1, mixVNDtoUSA } from "services/mixin";
import { message, Modal as AntModal } from "antd";

const stripePromise = loadStripe(VITE_STRIPE_PUBLIC_KEY)
interface props {
  user: any;
  detail: any;
}
const StripeCheckout: React.FC<props> = ({ user, detail }) => {
  const stripe = useStripe()
  const elements = useElements()
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [cardName, setCardName] = useState('')
  const [open, setOpen] = useState(false);
  const [cardComplete, setCardComplete] = useState({
    number: false,
    expiry: false,
    cvc: false,
  });
  const isCardComplete = cardComplete.number && cardComplete.expiry && cardComplete.cvc;
  const [visibleIconIndex, setVisibleIconIndex] = useState(1)

  const handleCancle = () => {
    setOpen(false);
    window.location.reload();
  }
  const handlePayment = () => {
    setOpen(false);
    navigate("/payment"); // chuyển về trang chủ
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    if(user) {
      try {
        const res = await mixPostV1('/api/v1/fe/order/create_v2_test', {
          customer_id: user.info.id,
          total: mixVNDtoUSA((detail.price)*100),
          package_id: detail.id,
          payment: 3,
          is_subscription: 0,
        })
        if(res.status) {
          const clientSecret = res.data.response_stripe.client_secret
          const email = user.info.email
          handleStripe(clientSecret, email)
        } else {
          toast.error(res.error.error)
          setLoading(false)
        }
      } catch (err) {
        toast.error(err?.message || 'Có lỗi')
        console.log(err)
      }
    }
  }
  const handleStripe = async (clientSecret:any, email:any) => {
    if(!stripe || !elements) {
      message.error("Stripe chưa được khởi tạo.")
      return
    }

    const card = elements?.getElement(CardNumberElement);
    if (!card) {
        console.error("Không tìm thấy Card Element.")
        setLoading(false)
        return
    }
    try {
      const res = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
            card,
            billing_details: { 
              email,
              name: cardName
            },
        },
      })
      if (res.error) {
        console.error("Stripe error:", res.error.message)
        toast.error("Thanh toán thất bại, vui lòng thử lại");
      } else if (res.paymentIntent?.status === "succeeded") {
        setLoading(false)
        setOpen(true)
      }
    }catch (err: any) {
      console.error(err)
      message.error("Đã xảy ra lỗi không xác định.")
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleIconIndex(prev => (prev >= 4 ? 1 : prev + 1))
    }, 3000)

    return () => clearInterval(interval)
  },[])
  return (
    <form 
      // onSubmit={handleSubmit}
      className="AnimatePresence-inner"
    >
      <div className="AccordionItemContent PaymentMethodFormAccordionItem PaymentMethodFormAccordionItem--selected PaymentMethodFormAccordionItem--overflowVisible-content AccordionItemContent--no-title">
        <div>
          <div>
            <div
              className="PaymentForm-paymentMethodForm flex-container direction-column wrap-wrap"
              style={{ gap: 16 }}
            >
              <div className="flex-item width-12">
                <div
                  className="FormFieldGroup"
                  data-qa="FormFieldGroup-cardForm"
                >
                  <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                    <label htmlFor="cardForm-fieldset">
                      <span className="Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">
                        Payment card details
                      </span>
                    </label>
                  </div>
                  <fieldset
                    className="FormFieldGroup-Fieldset"
                    id="cardForm-fieldset"
                  >
                    <div className="FormFieldGroup-container">
                      <div className="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop">
                        <div className="FormFieldInput padding-right-120">
                          <div className="CheckoutInputContainer">
                            {/* <span className="InputContainer">
                              <input
                                className="CheckoutInput CheckoutInput--tabularnums Input Input--empty"
                                autoComplete="cc-number"
                                autoCorrect="off"
                                spellCheck="false"
                                id="cardNumber"
                                name="cardNumber"
                                type="text"
                                inputMode="numeric"
                                aria-label="Số thẻ"
                                placeholder="1234 1234 1234 1234"
                                aria-invalid="false"
                                aria-describedby=""
                                data-1p-ignore="false"
                                data-lp-ignore="false"
                                defaultValue=""
                              />
                            </span> */}
                            <div 
                              style={{
                                borderTopRightRadius: "6px",
                                borderTopLeftRadius: "6px",
                                padding: "8px 12px",
                                boxShadow:
                                  "0 0 0 1px #e0e0e0, 0 2px 4px rgba(0, 0, 0, 0.07), 0 1px 1.5px rgba(0, 0, 0, 0.05)"
                              }}
                            >
                              <CardNumberElement
                                onChange={(e) => setCardComplete(prev => ({ ...prev, number: e.complete }))}
                                options={{
                                  showIcon: true,}}
                              />
                            </div>
                          </div>
                          <div
                            className="FormFieldInput-Icons"
                            style={{
                              opacity: 1
                            }}
                          >
                            <div
                              style={{
                                transform:
                                  "none"
                              }}
                            >
                              <span className="FormFieldInput-IconsIcon is-visible">
                                <img
                                  src="https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg"
                                  alt="Visa"
                                  className="BrandIcon"
                                  loading="lazy"
                                  fetchpriority="low"
                                />
                              </span>
                            </div>
                            <div
                              style={{
                                transform:
                                  "none"
                              }}
                            >
                              <span className="FormFieldInput-IconsIcon is-visible">
                                <img
                                  src="https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg"
                                  alt="MasterCard"
                                  className="BrandIcon"
                                  loading="lazy"
                                  fetchpriority="low"
                                />
                              </span>
                            </div>
                            <div
                              style={{
                                transform:
                                  "none"
                              }}
                            >
                              <span className="FormFieldInput-IconsIcon is-visible">
                                <img
                                  src="https://js.stripe.com/v3/fingerprinted/img/amex-a49b82f46c5cd6a96a6e418a6ca1717c.svg"
                                  alt="American Express"
                                  className="BrandIcon"
                                  loading="lazy"
                                  fetchpriority="low"
                                />
                              </span>
                            </div>
                            <div className="CardFormFieldGroupIconOverflow">
                              <span
                                className={`CardFormFieldGroupIconOverflow-Item ${visibleIconIndex === 1 ? 'CardFormFieldGroupIconOverflow-Item--visible': 'CardFormFieldGroupIconOverflow-Item--invisible'}`}
                                role="presentation"
                              >
                                <span
                                  className="FormFieldInput-IconsIcon"
                                  role="presentation"
                                >
                                  <img
                                    src="https://js.stripe.com/v3/fingerprinted/img/unionpay-8a10aefc7295216c338ba4e1224627a1.svg"
                                    alt="UnionPay"
                                    className="BrandIcon"
                                    loading="lazy"
                                    fetchpriority="low"
                                  />
                                </span>
                              </span>
                              <span
                                className={`CardFormFieldGroupIconOverflow-Item ${visibleIconIndex === 2 ? 'CardFormFieldGroupIconOverflow-Item--visible': 'CardFormFieldGroupIconOverflow-Item--invisible'}`}
                              >
                                <span
                                  className="FormFieldInput-IconsIcon"
                                  role="presentation"
                                >
                                  <img
                                    src="https://js.stripe.com/v3/fingerprinted/img/jcb-271fd06e6e7a2c52692ffa91a95fb64f.svg"
                                    alt="JCB"
                                    className="BrandIcon"
                                    loading="lazy"
                                    fetchpriority="low"
                                  />
                                </span>
                              </span>
                              <span
                                className={`CardFormFieldGroupIconOverflow-Item ${visibleIconIndex === 3 ? 'CardFormFieldGroupIconOverflow-Item--visible': 'CardFormFieldGroupIconOverflow-Item--invisible'}`}
                                role="presentation"
                              >
                                <span
                                  className="FormFieldInput-IconsIcon"
                                  role="presentation"
                                >
                                  <img
                                    src="https://js.stripe.com/v3/fingerprinted/img/discover-ac52cd46f89fa40a29a0bfb954e33173.svg"
                                    alt="Discover"
                                    className="BrandIcon"
                                    loading="lazy"
                                    fetchpriority="low"
                                  />
                                </span>
                              </span>
                              <span
                                className={`CardFormFieldGroupIconOverflow-Item ${visibleIconIndex === 4 ? 'CardFormFieldGroupIconOverflow-Item--visible': 'CardFormFieldGroupIconOverflow-Item--invisible'}`}
                                role="presentation"
                              >
                                <span
                                  className="FormFieldInput-IconsIcon"
                                  role="presentation"
                                >
                                  <img
                                    src="https://js.stripe.com/v3/fingerprinted/img/diners-fbcbd3360f8e3f629cdaa80e93abdb8b.svg"
                                    alt="Diners Club"
                                    className="BrandIcon"
                                    loading="lazy"
                                    fetchpriority="low"
                                  />
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="FormFieldGroup-child FormFieldGroup-child--width-6 FormFieldGroup-childLeft FormFieldGroup-childBottom">
                        <div className="FormFieldInput">
                          <div className="CheckoutInputContainer">
                            <div
                              style={{
                                borderBottomLeftRadius: "6px",
                                padding: "8px 12px",
                                boxShadow:
                                  "0 0 0 1px #e0e0e0, 0 2px 4px rgba(0, 0, 0, 0.07), 0 1px 1.5px rgba(0, 0, 0, 0.05)"
                              }}
                            >
                              <CardExpiryElement onChange={(e) => setCardComplete(prev => ({ ...prev, expiry: e.complete }))}/>
                            </div>
                            {/* <span className="InputContainer">
                              <input
                                className="CheckoutInput CheckoutInput--tabularnums Input Input--empty"
                                autoComplete="cc-exp"
                                autoCorrect="off"
                                spellCheck="false"
                                id="cardExpiry"
                                name="cardExpiry"
                                type="text"
                                inputMode="numeric"
                                aria-label="Ngày hết hạn"
                                placeholder="MM / YY"
                                aria-invalid="false"
                                aria-describedby=""
                                data-1p-ignore="false"
                                data-lp-ignore="false"
                                defaultValue=""
                              />
                            </span> */}
                          </div>
                        </div>
                      </div>
                      <div className="FormFieldGroup-child FormFieldGroup-child--width-6 FormFieldGroup-childRight FormFieldGroup-childBottom">
                        <div className="FormFieldInput has-icon padding-right-32">
                          <div className="CheckoutInputContainer">
                            <div
                              style={{
                                borderBottomRightRadius: "6px",
                                padding: "8px 12px",
                                boxShadow:
                                  "0 0 0 1px #e0e0e0, 0 2px 4px rgba(0, 0, 0, 0.07), 0 1px 1.5px rgba(0, 0, 0, 0.05)"
                              }}
                            >
                              <CardCvcElement onChange={(e) => setCardComplete(prev => ({ ...prev, cvc: e.complete }))}/>
                            </div>
                            {/* <span className="InputContainer">
                              <input
                                className="CheckoutInput CheckoutInput--tabularnums Input Input--empty"
                                autoComplete="cc-csc"
                                autoCorrect="off"
                                spellCheck="false"
                                id="cardCvc"
                                name="cardCvc"
                                type="text"
                                inputMode="numeric"
                                aria-label="CVC"
                                placeholder="CVC"
                                aria-invalid="false"
                                aria-describedby=""
                                data-1p-ignore="false"
                                data-lp-ignore="false"
                                defaultValue=""
                              />
                            </span> */}
                          </div>
                          <div
                            className="FormFieldInput-Icon is-loaded"
                            data-testid="FormFieldInput-Icon"
                          >
                            <div className="Icon Icon--md">
                              <svg
                                className="Icon Icon--md"
                                width={30}
                                height={20}
                                viewBox="0 0 30 20"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="var(--colorIconCardCvc)"
                                role="img"
                                aria-labelledby="cvcIconTitle"
                              >
                                <title id="cvcIconTitle">
                                  Credit or
                                  debit card CVC
                                </title>
                                <g opacity="0.74">
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M25.2061 0.00488281C27.3194 0.112115 29 1.85996 29 4V11.3291C28.5428 11.0304 28.0336 10.8304 27.5 10.7188V8H1.5V16C1.5 17.3807 2.61929 18.5 4 18.5H10.1104V20H4L3.79395 19.9951C1.7488 19.8913 0.108652 18.2512 0.00488281 16.2061L0 16V4C0 1.85996 1.68056 0.112115 3.79395 0.00488281L4 0H25L25.2061 0.00488281ZM4 1.5C2.61929 1.5 1.5 2.61929 1.5 4V5H27.5V4C27.5 2.61929 26.3807 1.5 25 1.5H4Z"
                                  />
                                  <path d="M27.5 12.7988C28.3058 13.1128 28.7725 13.7946 28.7725 14.6406C28.7722 15.4002 28.2721 15.9399 27.6523 16.1699C28.1601 16.3319 28.6072 16.6732 28.8086 17.2207C28.3597 18.6222 27.1605 19.6862 25.6826 19.9404C24.8389 19.7707 24.1662 19.2842 23.834 18.5H25C25.0914 18.5 25.1816 18.4939 25.2705 18.4844C25.5434 18.7862 25.9284 18.9501 26.3623 18.9502C27.142 18.9501 27.6922 18.5297 27.6924 17.79C27.6923 17.4212 27.5473 17.1544 27.2998 16.9795C27.4281 16.6786 27.5 16.3478 27.5 16V15.0527C27.5397 14.9481 27.5625 14.8309 27.5625 14.7002C27.5625 14.5657 27.5399 14.4422 27.5 14.3311V12.7988Z" />
                                  <path d="M15.2207 18.5V18.8301H16.8799V19.9004H12.1104V18.8301H13.9902V18.5H15.2207Z" />
                                  <path d="M19.9307 18.5L19.5762 18.7803H22.8369V19.9004H17.8164V18.8604L18.2549 18.5H19.9307Z" />
                                </g>
                                <path d="M26.3822 20.01C24.9722 20.01 23.8522 19.25 23.6422 17.81L24.8722 17.58C24.9922 18.45 25.6022 18.95 26.3622 18.95C27.1422 18.95 27.6922 18.53 27.6922 17.79C27.6922 17.05 27.1122 16.72 26.2822 16.72H25.5722V15.67H26.3022C27.0622 15.67 27.5622 15.34 27.5622 14.7C27.5622 14.07 27.1022 13.68 26.3922 13.68C25.6422 13.68 25.1322 14.18 24.9822 14.92L23.8122 14.76C24.0022 13.55 24.9822 12.61 26.4322 12.61C27.8822 12.61 28.7722 13.47 28.7722 14.64C28.7722 15.4 28.2722 15.94 27.6522 16.17C28.3422 16.39 28.9222 16.94 28.9222 17.89C28.9222 19.04 27.9522 20.01 26.3822 20.01Z" />
                                <path d="M17.8161 18.86L19.6161 17.38C20.5961 16.58 21.4761 15.87 21.4761 14.97C21.4761 14.23 21.0161 13.7 20.2561 13.7C19.5061 13.7 19.0161 14.29 19.0161 15C19.0161 15.23 19.0561 15.46 19.1361 15.68H17.9461C17.8461 15.39 17.8161 15.2 17.8161 14.93C17.8161 13.58 18.9261 12.61 20.2861 12.61C21.7861 12.61 22.7461 13.54 22.7461 14.89C22.7461 16.16 21.7861 17.03 20.7761 17.83L19.5761 18.78H22.8361V19.9H17.8161V18.86Z" />
                                <path d="M14.25 12.67H15.22V18.83H16.88V19.9H12.11V18.83H13.99V14.92H12.15V13.99L12.88 13.93C13.78 13.86 14.18 13.58 14.25 12.67Z" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="FieldError-container"
                        style={{
                          opacity: 0,
                          height: 0,
                          marginTop: 0
                        }}
                      >
                        <span className="FieldError Text Text-color--red Text-fontSize--13">
                          <span aria-hidden="true" />
                        </span>
                      </div>
                    </div>
                    <div
                      className="FieldError-container"
                      style={{
                        opacity: 0,
                        height: 0,
                        marginTop: 0
                      }}
                    >
                      <span className="FieldError Text Text-color--red Text-fontSize--13">
                        <span aria-hidden="true" />
                      </span>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div className="BillingInfoForm flex-item width-grow">
                <div className="AnimateSinglePresence">
                  <div className="AnimateSinglePresenceItem">
                    <div>
                      <div
                        className="BillingInfoForm-addressInput flex-item width-12"
                        aria-hidden="false"
                        style={{ marginTop: 0 }}
                      >
                        <div
                          role="group"
                          aria-label="Địa chỉ thanh toán"
                        >
                          <div className="flex-container spacing-16 direction-column wrap-wrap">
                            <div className="flex-item width-12">
                              <div
                                className="FormFieldGroup"
                                data-qa="FormFieldGroup-billingName"
                              >
                                <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                                  <label htmlFor="billingName">
                                    <span className="Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">
                                      Name on card
                                    </span>
                                  </label>
                                </div>
                                <div
                                  className="FormFieldGroup-Fieldset"
                                  id="billingName-fieldset"
                                >
                                  <div className="FormFieldGroup-container">
                                    <div className="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop FormFieldGroup-childBottom">
                                      <div className="FormFieldInput">
                                        <div className="CheckoutInputContainer">
                                          <span className="InputContainer">
                                            <input
                                              className="CheckoutInput Input Input--empty"
                                              type="text"
                                              placeholder="Enter your name"
                                              value={cardName}
                                              onChange={(e) => setCardName(e.target.value)}
                                            />
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      className="FieldError-container"
                                      style={{
                                        opacity: 0,
                                        height: 0,
                                        marginTop: 0
                                      }}
                                    >
                                      <span className="FieldError Text Text-color--red Text-fontSize--13">
                                        <span aria-hidden="true" />
                                      </span>
                                    </div>
                                  </div>
                                  <div
                                    className="FieldError-container"
                                    style={{
                                      opacity: 0,
                                      height: 0,
                                      marginTop: 0
                                    }}
                                  >
                                    <span className="FieldError Text Text-color--red Text-fontSize--13">
                                      <span aria-hidden="true" />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {/* <div className="flex-item width-12">
                                                              <div
                                                                className="FormFieldGroup"
                                                                data-qa="FormFieldGroup-countryWithOptionalPostalCodeInput"
                                                              >
                                                                <div className="FormFieldGroup-labelContainer flex-container justify-content-space-between">
                                                                  <label htmlFor="country">
                                                                    <span className="Text Text-color--gray600 Text-fontSize--13 Text-fontWeight--500">
                                                                      Quốc gia
                                                                      hoặc khu
                                                                      vực
                                                                    </span>
                                                                  </label>
                                                                </div>
                                                                <div
                                                                  className="FormFieldGroup-Fieldset"
                                                                  id="countryWithOptionalPostalCodeInput-fieldset"
                                                                >
                                                                  <div className="FormFieldGroup-container">
                                                                    <div className="FormFieldGroup-child FormFieldGroup-child--width-12 FormFieldGroup-childLeft FormFieldGroup-childRight FormFieldGroup-childTop FormFieldGroup-childBottom">
                                                                      <div className="FormFieldInput is-select">
                                                                        <div>
                                                                          <div className="Select">
                                                                            <select
                                                                              id="billingCountry"
                                                                              name="billingCountry"
                                                                              autoComplete="billing country"
                                                                              aria-label="Quốc gia hoặc khu vực"
                                                                              className="Select-source"
                                                                            >
                                                                              <option
                                                                                value=""
                                                                                disabled=""
                                                                                hidden=""
                                                                              />
                                                                              <option value="SA">
                                                                                Ả
                                                                                Rập
                                                                                Xê-út
                                                                              </option>
                                                                              <option value="AF">
                                                                                Afghanistan
                                                                              </option>
                                                                              <option value="EG">
                                                                                Ai
                                                                                Cập
                                                                              </option>
                                                                              <option value="AL">
                                                                                Albania
                                                                              </option>
                                                                              <option value="DZ">
                                                                                Algeria
                                                                              </option>
                                                                              <option value="AD">
                                                                                Andorra
                                                                              </option>
                                                                              <option value="AO">
                                                                                Angola
                                                                              </option>
                                                                              <option value="AI">
                                                                                Anguilla
                                                                              </option>
                                                                              <option value="AG">
                                                                                Antigua
                                                                                và
                                                                                Barbuda
                                                                              </option>
                                                                              <option value="AT">
                                                                                Áo
                                                                              </option>
                                                                              <option value="AR">
                                                                                Argentina
                                                                              </option>
                                                                              <option value="AM">
                                                                                Armenia
                                                                              </option>
                                                                              <option value="AW">
                                                                                Aruba
                                                                              </option>
                                                                              <option value="AU">
                                                                                Australia
                                                                              </option>
                                                                              <option value="AZ">
                                                                                Azerbaijan
                                                                              </option>
                                                                              <option value="IN">
                                                                                Ấn
                                                                                Độ
                                                                              </option>
                                                                              <option value="PL">
                                                                                Ba
                                                                                Lan
                                                                              </option>
                                                                              <option value="BS">
                                                                                Bahamas
                                                                              </option>
                                                                              <option value="BH">
                                                                                Bahrain
                                                                              </option>
                                                                              <option value="BD">
                                                                                Bangladesh
                                                                              </option>
                                                                              <option value="BB">
                                                                                Barbados
                                                                              </option>
                                                                              <option value="MK">
                                                                                Bắc
                                                                                Macedonia
                                                                              </option>
                                                                              <option value="BY">
                                                                                Belarus
                                                                              </option>
                                                                              <option value="BZ">
                                                                                Belize
                                                                              </option>
                                                                              <option value="BJ">
                                                                                Benin
                                                                              </option>
                                                                              <option value="BM">
                                                                                Bermuda
                                                                              </option>
                                                                              <option value="BT">
                                                                                Bhutan
                                                                              </option>
                                                                              <option value="BE">
                                                                                Bỉ
                                                                              </option>
                                                                              <option value="BO">
                                                                                Bolivia
                                                                              </option>
                                                                              <option value="BA">
                                                                                Bosnia
                                                                                và
                                                                                Herzegovina
                                                                              </option>
                                                                              <option value="BW">
                                                                                Botswana
                                                                              </option>
                                                                              <option value="PT">
                                                                                Bồ
                                                                                Đào
                                                                                Nha
                                                                              </option>
                                                                              <option value="BR">
                                                                                Brazil
                                                                              </option>
                                                                              <option value="BN">
                                                                                Brunei
                                                                              </option>
                                                                              <option value="BG">
                                                                                Bulgaria
                                                                              </option>
                                                                              <option value="BF">
                                                                                Burkina
                                                                                Faso
                                                                              </option>
                                                                              <option value="BI">
                                                                                Burundi
                                                                              </option>
                                                                              <option value="BQ">
                                                                                Ca-ri-bê
                                                                                Hà
                                                                                Lan
                                                                              </option>
                                                                              <option value="AE">
                                                                                Các
                                                                                Tiểu
                                                                                Vương
                                                                                quốc
                                                                                Ả
                                                                                Rập
                                                                                Thống
                                                                                nhất
                                                                              </option>
                                                                              <option value="CM">
                                                                                Cameroon
                                                                              </option>
                                                                              <option value="KH">
                                                                                Campuchia
                                                                              </option>
                                                                              <option value="CA">
                                                                                Canada
                                                                              </option>
                                                                              <option value="CV">
                                                                                Cape
                                                                                Verde
                                                                              </option>
                                                                              <option value="TD">
                                                                                Chad
                                                                              </option>
                                                                              <option value="CL">
                                                                                Chile
                                                                              </option>
                                                                              <option value="CO">
                                                                                Colombia
                                                                              </option>
                                                                              <option value="KM">
                                                                                Comoros
                                                                              </option>
                                                                              <option value="CG">
                                                                                Congo
                                                                                -
                                                                                Brazzaville
                                                                              </option>
                                                                              <option value="CD">
                                                                                Congo
                                                                                -
                                                                                Kinshasa
                                                                              </option>
                                                                              <option value="CR">
                                                                                Costa
                                                                                Rica
                                                                              </option>
                                                                              <option value="DO">
                                                                                Cộng
                                                                                hòa
                                                                                Dominica
                                                                              </option>
                                                                              <option value="CF">
                                                                                Cộng
                                                                                hòa
                                                                                Trung
                                                                                Phi
                                                                              </option>
                                                                              <option value="CI">
                                                                                Côte
                                                                                d’Ivoire
                                                                              </option>
                                                                              <option value="HR">
                                                                                Croatia
                                                                              </option>
                                                                              <option value="CW">
                                                                                Curaçao
                                                                              </option>
                                                                              <option value="DJ">
                                                                                Djibouti
                                                                              </option>
                                                                              <option value="DM">
                                                                                Dominica
                                                                              </option>
                                                                              <option value="TW">
                                                                                Đài
                                                                                Loan
                                                                              </option>
                                                                              <option value="DK">
                                                                                Đan
                                                                                Mạch
                                                                              </option>
                                                                              <option value="AC">
                                                                                Đảo
                                                                                Ascension
                                                                              </option>
                                                                              <option value="BV">
                                                                                Đảo
                                                                                Bouvet
                                                                              </option>
                                                                              <option value="IM">
                                                                                Đảo
                                                                                Man
                                                                              </option>
                                                                              <option value="DE">
                                                                                Đức
                                                                              </option>
                                                                              <option value="EC">
                                                                                Ecuador
                                                                              </option>
                                                                              <option value="SV">
                                                                                El
                                                                                Salvador
                                                                              </option>
                                                                              <option value="ER">
                                                                                Eritrea
                                                                              </option>
                                                                              <option value="EE">
                                                                                Estonia
                                                                              </option>
                                                                              <option value="ET">
                                                                                Ethiopia
                                                                              </option>
                                                                              <option value="FJ">
                                                                                Fiji
                                                                              </option>
                                                                              <option value="GA">
                                                                                Gabon
                                                                              </option>
                                                                              <option value="GM">
                                                                                Gambia
                                                                              </option>
                                                                              <option value="GE">
                                                                                Georgia
                                                                              </option>
                                                                              <option value="GH">
                                                                                Ghana
                                                                              </option>
                                                                              <option value="GI">
                                                                                Gibraltar
                                                                              </option>
                                                                              <option value="GL">
                                                                                Greenland
                                                                              </option>
                                                                              <option value="GD">
                                                                                Grenada
                                                                              </option>
                                                                              <option value="GP">
                                                                                Guadeloupe
                                                                              </option>
                                                                              <option value="GU">
                                                                                Guam
                                                                              </option>
                                                                              <option value="GT">
                                                                                Guatemala
                                                                              </option>
                                                                              <option value="GG">
                                                                                Guernsey
                                                                              </option>
                                                                              <option value="GF">
                                                                                Guiana
                                                                                thuộc
                                                                                Pháp
                                                                              </option>
                                                                              <option value="GN">
                                                                                Guinea
                                                                              </option>
                                                                              <option value="GQ">
                                                                                Guinea
                                                                                Xích
                                                                                Đạo
                                                                              </option>
                                                                              <option value="GW">
                                                                                Guinea-Bissau
                                                                              </option>
                                                                              <option value="GY">
                                                                                Guyana
                                                                              </option>
                                                                              <option value="NL">
                                                                                Hà
                                                                                Lan
                                                                              </option>
                                                                              <option value="HT">
                                                                                Haiti
                                                                              </option>
                                                                              <option value="KR">
                                                                                Hàn
                                                                                Quốc
                                                                              </option>
                                                                              <option value="US">
                                                                                Hoa
                                                                                Kỳ
                                                                              </option>
                                                                              <option value="HN">
                                                                                Honduras
                                                                              </option>
                                                                              <option value="HK">
                                                                                Hồng
                                                                                Kông,
                                                                                Trung
                                                                                Quốc
                                                                              </option>
                                                                              <option value="HU">
                                                                                Hungary
                                                                              </option>
                                                                              <option value="GR">
                                                                                Hy
                                                                                Lạp
                                                                              </option>
                                                                              <option value="IS">
                                                                                Iceland
                                                                              </option>
                                                                              <option value="ID">
                                                                                Indonesia
                                                                              </option>
                                                                              <option value="IQ">
                                                                                Iraq
                                                                              </option>
                                                                              <option value="IE">
                                                                                Ireland
                                                                              </option>
                                                                              <option value="IL">
                                                                                Israel
                                                                              </option>
                                                                              <option value="IT">
                                                                                Italy
                                                                              </option>
                                                                              <option value="JM">
                                                                                Jamaica
                                                                              </option>
                                                                              <option value="JE">
                                                                                Jersey
                                                                              </option>
                                                                              <option value="JO">
                                                                                Jordan
                                                                              </option>
                                                                              <option value="KZ">
                                                                                Kazakhstan
                                                                              </option>
                                                                              <option value="KE">
                                                                                Kenya
                                                                              </option>
                                                                              <option value="KI">
                                                                                Kiribati
                                                                              </option>
                                                                              <option value="XK">
                                                                                Kosovo
                                                                              </option>
                                                                              <option value="KW">
                                                                                Kuwait
                                                                              </option>
                                                                              <option value="KG">
                                                                                Kyrgyzstan
                                                                              </option>
                                                                              <option value="IO">
                                                                                Lãnh
                                                                                thổ
                                                                                Ấn
                                                                                Độ
                                                                                Dương
                                                                                thuộc
                                                                                Anh
                                                                              </option>
                                                                              <option value="PS">
                                                                                Lãnh
                                                                                thổ
                                                                                Palestine
                                                                              </option>
                                                                              <option value="TF">
                                                                                Lãnh
                                                                                thổ
                                                                                phía
                                                                                Nam
                                                                                Thuộc
                                                                                Pháp
                                                                              </option>
                                                                              <option value="LA">
                                                                                Lào
                                                                              </option>
                                                                              <option value="LV">
                                                                                Latvia
                                                                              </option>
                                                                              <option value="LS">
                                                                                Lesotho
                                                                              </option>
                                                                              <option value="LB">
                                                                                Li-băng
                                                                              </option>
                                                                              <option value="LR">
                                                                                Liberia
                                                                              </option>
                                                                              <option value="LY">
                                                                                Libya
                                                                              </option>
                                                                              <option value="LI">
                                                                                Liechtenstein
                                                                              </option>
                                                                              <option value="LT">
                                                                                Litva
                                                                              </option>
                                                                              <option value="LU">
                                                                                Luxembourg
                                                                              </option>
                                                                              <option value="MA">
                                                                                Ma-rốc
                                                                              </option>
                                                                              <option value="MO">
                                                                                Macao,
                                                                                Trung
                                                                                Quốc
                                                                              </option>
                                                                              <option value="MG">
                                                                                Madagascar
                                                                              </option>
                                                                              <option value="MW">
                                                                                Malawi
                                                                              </option>
                                                                              <option value="MY">
                                                                                Malaysia
                                                                              </option>
                                                                              <option value="MV">
                                                                                Maldives
                                                                              </option>
                                                                              <option value="ML">
                                                                                Mali
                                                                              </option>
                                                                              <option value="MT">
                                                                                Malta
                                                                              </option>
                                                                              <option value="MQ">
                                                                                Martinique
                                                                              </option>
                                                                              <option value="MR">
                                                                                Mauritania
                                                                              </option>
                                                                              <option value="MU">
                                                                                Mauritius
                                                                              </option>
                                                                              <option value="YT">
                                                                                Mayotte
                                                                              </option>
                                                                              <option value="MX">
                                                                                Mexico
                                                                              </option>
                                                                              <option value="MD">
                                                                                Moldova
                                                                              </option>
                                                                              <option value="MC">
                                                                                Monaco
                                                                              </option>
                                                                              <option value="ME">
                                                                                Montenegro
                                                                              </option>
                                                                              <option value="MS">
                                                                                Montserrat
                                                                              </option>
                                                                              <option value="MZ">
                                                                                Mozambique
                                                                              </option>
                                                                              <option value="MN">
                                                                                Mông
                                                                                Cổ
                                                                              </option>
                                                                              <option value="MM">
                                                                                Myanmar
                                                                                (Miến
                                                                                Điện)
                                                                              </option>
                                                                              <option value="NO">
                                                                                Na
                                                                                Uy
                                                                              </option>
                                                                              <option value="AQ">
                                                                                Nam
                                                                                Cực
                                                                              </option>
                                                                              <option value="GS">
                                                                                Nam
                                                                                Georgia
                                                                                &amp;
                                                                                Quần
                                                                                đảo
                                                                                Nam
                                                                                Sandwich
                                                                              </option>
                                                                              <option value="ZA">
                                                                                Nam
                                                                                Phi
                                                                              </option>
                                                                              <option value="SS">
                                                                                Nam
                                                                                Sudan
                                                                              </option>
                                                                              <option value="NA">
                                                                                Namibia
                                                                              </option>
                                                                              <option value="NR">
                                                                                Nauru
                                                                              </option>
                                                                              <option value="NP">
                                                                                Nepal
                                                                              </option>
                                                                              <option value="NC">
                                                                                New
                                                                                Caledonia
                                                                              </option>
                                                                              <option value="NZ">
                                                                                New
                                                                                Zealand
                                                                              </option>
                                                                              <option value="RU">
                                                                                Nga
                                                                              </option>
                                                                              <option value="JP">
                                                                                Nhật
                                                                                Bản
                                                                              </option>
                                                                              <option value="NI">
                                                                                Nicaragua
                                                                              </option>
                                                                              <option value="NE">
                                                                                Niger
                                                                              </option>
                                                                              <option value="NG">
                                                                                Nigeria
                                                                              </option>
                                                                              <option value="NU">
                                                                                Niue
                                                                              </option>
                                                                              <option value="OM">
                                                                                Oman
                                                                              </option>
                                                                              <option value="PK">
                                                                                Pakistan
                                                                              </option>
                                                                              <option value="PA">
                                                                                Panama
                                                                              </option>
                                                                              <option value="PG">
                                                                                Papua
                                                                                New
                                                                                Guinea
                                                                              </option>
                                                                              <option value="PY">
                                                                                Paraguay
                                                                              </option>
                                                                              <option value="PE">
                                                                                Peru
                                                                              </option>
                                                                              <option value="FR">
                                                                                Pháp
                                                                              </option>
                                                                              <option value="FI">
                                                                                Phần
                                                                                Lan
                                                                              </option>
                                                                              <option value="PH">
                                                                                Philippines
                                                                              </option>
                                                                              <option value="PF">
                                                                                Polynesia
                                                                                thuộc
                                                                                Pháp
                                                                              </option>
                                                                              <option value="PR">
                                                                                Puerto
                                                                                Rico
                                                                              </option>
                                                                              <option value="QA">
                                                                                Qatar
                                                                              </option>
                                                                              <option value="AX">
                                                                                Quần
                                                                                đảo
                                                                                Åland
                                                                              </option>
                                                                              <option value="KY">
                                                                                Quần
                                                                                đảo
                                                                                Cayman
                                                                              </option>
                                                                              <option value="CK">
                                                                                Quần
                                                                                đảo
                                                                                Cook
                                                                              </option>
                                                                              <option value="FK">
                                                                                Quần
                                                                                đảo
                                                                                Falkland
                                                                              </option>
                                                                              <option value="FO">
                                                                                Quần
                                                                                đảo
                                                                                Faroe
                                                                              </option>
                                                                              <option value="PN">
                                                                                Quần
                                                                                đảo
                                                                                Pitcairn
                                                                              </option>
                                                                              <option value="SB">
                                                                                Quần
                                                                                đảo
                                                                                Solomon
                                                                              </option>
                                                                              <option value="TC">
                                                                                Quần
                                                                                đảo
                                                                                Turks
                                                                                và
                                                                                Caicos
                                                                              </option>
                                                                              <option value="VG">
                                                                                Quần
                                                                                đảo
                                                                                Virgin
                                                                                thuộc
                                                                                Anh
                                                                              </option>
                                                                              <option value="RE">
                                                                                Réunion
                                                                              </option>
                                                                              <option value="RO">
                                                                                Romania
                                                                              </option>
                                                                              <option value="RW">
                                                                                Rwanda
                                                                              </option>
                                                                              <option value="PM">
                                                                                Saint
                                                                                Pierre
                                                                                và
                                                                                Miquelon
                                                                              </option>
                                                                              <option value="WS">
                                                                                Samoa
                                                                              </option>
                                                                              <option value="SM">
                                                                                San
                                                                                Marino
                                                                              </option>
                                                                              <option value="ST">
                                                                                São
                                                                                Tomé
                                                                                và
                                                                                Príncipe
                                                                              </option>
                                                                              <option value="CZ">
                                                                                Séc
                                                                              </option>
                                                                              <option value="SN">
                                                                                Senegal
                                                                              </option>
                                                                              <option value="RS">
                                                                                Serbia
                                                                              </option>
                                                                              <option value="SC">
                                                                                Seychelles
                                                                              </option>
                                                                              <option value="SL">
                                                                                Sierra
                                                                                Leone
                                                                              </option>
                                                                              <option value="SG">
                                                                                Singapore
                                                                              </option>
                                                                              <option value="SX">
                                                                                Sint
                                                                                Maarten
                                                                              </option>
                                                                              <option value="CY">
                                                                                Síp
                                                                              </option>
                                                                              <option value="SK">
                                                                                Slovakia
                                                                              </option>
                                                                              <option value="SI">
                                                                                Slovenia
                                                                              </option>
                                                                              <option value="SO">
                                                                                Somalia
                                                                              </option>
                                                                              <option value="LK">
                                                                                Sri
                                                                                Lanka
                                                                              </option>
                                                                              <option value="BL">
                                                                                St.
                                                                                Barthélemy
                                                                              </option>
                                                                              <option value="SH">
                                                                                St.
                                                                                Helena
                                                                              </option>
                                                                              <option value="KN">
                                                                                St.
                                                                                Kitts
                                                                                và
                                                                                Nevis
                                                                              </option>
                                                                              <option value="LC">
                                                                                St.
                                                                                Lucia
                                                                              </option>
                                                                              <option value="MF">
                                                                                St.
                                                                                Martin
                                                                              </option>
                                                                              <option value="VC">
                                                                                St.
                                                                                Vincent
                                                                                và
                                                                                Grenadines
                                                                              </option>
                                                                              <option value="SD">
                                                                                Sudan
                                                                              </option>
                                                                              <option value="SR">
                                                                                Suriname
                                                                              </option>
                                                                              <option value="SJ">
                                                                                Svalbard
                                                                                và
                                                                                Jan
                                                                                Mayen
                                                                              </option>
                                                                              <option value="SZ">
                                                                                Swaziland
                                                                              </option>
                                                                              <option value="TJ">
                                                                                Tajikistan
                                                                              </option>
                                                                              <option value="TZ">
                                                                                Tanzania
                                                                              </option>
                                                                              <option value="ES">
                                                                                Tây
                                                                                Ban
                                                                                Nha
                                                                              </option>
                                                                              <option value="EH">
                                                                                Tây
                                                                                Sahara
                                                                              </option>
                                                                              <option value="TH">
                                                                                Thái
                                                                                Lan
                                                                              </option>
                                                                              <option value="VA">
                                                                                Thành
                                                                                Vatican
                                                                              </option>
                                                                              <option value="TR">
                                                                                Thổ
                                                                                Nhĩ
                                                                                Kỳ
                                                                              </option>
                                                                              <option value="SE">
                                                                                Thụy
                                                                                Điển
                                                                              </option>
                                                                              <option value="CH">
                                                                                Thụy
                                                                                Sĩ
                                                                              </option>
                                                                              <option value="TL">
                                                                                Timor-Leste
                                                                              </option>
                                                                              <option value="TG">
                                                                                Togo
                                                                              </option>
                                                                              <option value="TK">
                                                                                Tokelau
                                                                              </option>
                                                                              <option value="TO">
                                                                                Tonga
                                                                              </option>
                                                                              <option value="TT">
                                                                                Trinidad
                                                                                và
                                                                                Tobago
                                                                              </option>
                                                                              <option value="TA">
                                                                                Tristan
                                                                                da
                                                                                Cunha
                                                                              </option>
                                                                              <option value="CN">
                                                                                Trung
                                                                                Quốc
                                                                              </option>
                                                                              <option value="TN">
                                                                                Tunisia
                                                                              </option>
                                                                              <option value="TM">
                                                                                Turkmenistan
                                                                              </option>
                                                                              <option value="TV">
                                                                                Tuvalu
                                                                              </option>
                                                                              <option value="UG">
                                                                                Uganda
                                                                              </option>
                                                                              <option value="UA">
                                                                                Ukraina
                                                                              </option>
                                                                              <option value="UY">
                                                                                Uruguay
                                                                              </option>
                                                                              <option value="UZ">
                                                                                Uzbekistan
                                                                              </option>
                                                                              <option value="VU">
                                                                                Vanuatu
                                                                              </option>
                                                                              <option value="VE">
                                                                                Venezuela
                                                                              </option>
                                                                              <option value="VN">
                                                                                Việt
                                                                                Nam
                                                                              </option>
                                                                              <option value="GB">
                                                                                Vương
                                                                                quốc
                                                                                Anh
                                                                              </option>
                                                                              <option value="WF">
                                                                                Wallis
                                                                                và
                                                                                Futuna
                                                                              </option>
                                                                              <option value="YE">
                                                                                Yemen
                                                                              </option>
                                                                              <option value="ZM">
                                                                                Zambia
                                                                              </option>
                                                                              <option value="ZW">
                                                                                Zimbabwe
                                                                              </option>
                                                                            </select>
                                                                            <svg
                                                                              className="InlineSVG Icon Select-arrow Icon--sm"
                                                                              focusable="false"
                                                                              viewBox="0 0 12 12"
                                                                            >
                                                                              <path
                                                                                d="M10.193 3.97a.75.75 0 0 1 1.062 1.062L6.53 9.756a.75.75 0 0 1-1.06 0L.745 5.032A.75.75 0 0 1 1.807 3.97L6 8.163l4.193-4.193z"
                                                                                fillRule="evenodd"
                                                                              />
                                                                            </svg>
                                                                          </div>
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                    <div
                                                                      className="FieldError-container"
                                                                      style={{
                                                                        opacity: 0,
                                                                        height: 0,
                                                                        marginTop: 0
                                                                      }}
                                                                    >
                                                                      <span className="FieldError Text Text-color--red Text-fontSize--13">
                                                                        <span aria-hidden="true" />
                                                                      </span>
                                                                    </div>
                                                                  </div>
                                                                  <div
                                                                    className="FieldError-container"
                                                                    style={{
                                                                      opacity: 0,
                                                                      height: 0,
                                                                      marginTop: 0
                                                                    }}
                                                                  >
                                                                    <span className="FieldError Text Text-color--red Text-fontSize--13">
                                                                      <span aria-hidden="true" />
                                                                    </span>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Confirm Button */}
                <div className="flex justify-center">
                  <button
                    disabled={!isCardComplete}
                    onClick={handleSubmit}
                    className="w-[150px] h-[30px] btn-border-000000-cl-000000 transition duration-300"
                    style={
                      isCardComplete ? {opacity: 1} : {opacity: 0.4}
                    }
                  >
                    {loading ? "Loading..." : "Confirm"}
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>
      <AntModal
          open={open}
          footer={null}
          centered
          closable={false}
          onCancel={() => handleCancle()}
          width={320}
          bodyStyle={{ textAlign: "center" }}
        >
          <div className="flex flex-col items-center gap-[24px]">
            <div className="flex items-center justify-center">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2076_3332)">
                  <path d="M20.0002 3.3335C10.8002 3.3335 3.3335 10.8002 3.3335 20.0002C3.3335 29.2002 10.8002 36.6668 20.0002 36.6668C29.2002 36.6668 36.6668 29.2002 36.6668 20.0002C36.6668 10.8002 29.2002 3.3335 20.0002 3.3335ZM20.0002 33.3335C12.6502 33.3335 6.66683 27.3502 6.66683 20.0002C6.66683 12.6502 12.6502 6.66683 20.0002 6.66683C27.3502 6.66683 33.3335 12.6502 33.3335 20.0002C33.3335 27.3502 27.3502 33.3335 20.0002 33.3335ZM27.6502 12.6335L16.6668 23.6168L12.3502 19.3168L10.0002 21.6668L16.6668 28.3335L30.0002 15.0002L27.6502 12.6335Z" fill="#B0976E" />
                  <path d="M20.0002 3.3335C10.8002 3.3335 3.3335 10.8002 3.3335 20.0002C3.3335 29.2002 10.8002 36.6668 20.0002 36.6668C29.2002 36.6668 36.6668 29.2002 36.6668 20.0002C36.6668 10.8002 29.2002 3.3335 20.0002 3.3335ZM20.0002 33.3335C12.6502 33.3335 6.66683 27.3502 6.66683 20.0002C6.66683 12.6502 12.6502 6.66683 20.0002 6.66683C27.3502 6.66683 33.3335 12.6502 33.3335 20.0002C33.3335 27.3502 27.3502 33.3335 20.0002 33.3335ZM27.6502 12.6335L16.6668 23.6168L12.3502 19.3168L10.0002 21.6668L16.6668 28.3335L30.0002 15.0002L27.6502 12.6335Z" fill="white" fill-opacity="0.12" />
                </g>
                <defs>
                  <clipPath id="clip0_2076_3332">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h2 className="text-lg font-medium text-gray-900 mb-1">
              Order successful!
            </h2>
            <p className="text-gray-600 mb-6 text-sm">
              Thank you for your purchase of our {detail?.content?.val1} package.
            </p>
            <div
              onClick={handlePayment}
              className="w-full h-[40px] bg-btn-border-C1A875-cl-C1A875 transition duration-300 flex justify-center items-center"
            >
              Back Payment
            </div>
          </div>
        </AntModal>
    </form>
  )
}
const StripeForm: React.FC<props> = (props) => {
  return (
    <Elements stripe={stripePromise}>
      <StripeCheckout {...props}/>
    </Elements>
  )
}
export default StripeForm